import { create } from 'zustand'

/**
 * The PIN a respondent chose for a survey instance, held in memory only for the
 * lifetime of the page. It is deliberately not persisted (no localStorage /
 * sessionStorage), never put in a URL, and only ever leaves as the
 * `X-Survey-Pin` request header (see `axios-instance.ts`).
 */
type SurveyPinState = {
  instanceId: string | null
  pin: string | null
  setPin: (instanceId: string, pin: string) => void
  clearPin: () => void
}

export const useSurveyPin = create<SurveyPinState>((set) => ({
  instanceId: null,
  pin: null,
  setPin: (instanceId, pin) => set({ instanceId, pin }),
  clearPin: () => set({ instanceId: null, pin: null }),
}))
